import styled, { keyframes } from 'styled-components'

export const SliderWrapper = styled.div`
  position: relative;
  min-width: 330px;
  display: flex;
  align-items: center;
  padding-left: 50px;
`

export const Bar = styled.div`
  width: 2px;
  height: 100%;
  background: #cccccc;
`
export const BarFiller = styled.div`
  width: 2px;
  position: absolute;
  height: 9999px;
  background: #000;
  left: -34px;
  bottom: 0;
  transition: all 0.3s ease-in-out;
`
export const BarLimiter = styled.div`
  width: 2px;
  position: absolute;
  height: 100%;
  background: #cccccc;
  left: -34px;
  top: 5px;
  transition: all 0.3s ease-in-out;
`

export const BarWrapper = styled.div`
  height: 364px;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-left: 10px;
`

export const ListWrapper = styled.div`
  min-height: 318px;
  margin-top: 30px;
`

export const DownArrowWrapper = styled.div<{
  isLastSlide: boolean
}>`
  height: 100%;
  align-items: ${o => (o.isLastSlide ? 'start' : 'end')};
  max-height: ${o => (o.isLastSlide ? '475px' : '440px')};
  display: flex;
  left: 56px;
  position: absolute;
`

const slide = keyframes`
  from {
    top: 0;
    opacity: 1;
  }
  to {
    top: 35px;
    opacity: 0;
  }
`
const slideDown = keyframes`
  from {
    top: 35px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
`

export const ArrowWrapper = styled.div`
  height: 35px;
  position: relative;
`

export const Arrow = styled.div<{
  isLastSlide: boolean
}>`
  animation: ${o => (!o.isLastSlide ? slide : slideDown)} infinite 1.5s linear;
  position: absolute;
  rotate: ${o => (!o.isLastSlide ? '0deg' : '-180deg')};
`
